import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var config = {
  apiKey: "AIzaSyAeDdCHm4wFnvUrSiQMvFPCiPgjt0WGOH8",
  authDomain: "react-slack-clone-d5116.firebaseapp.com",
  databaseURL: "https://react-slack-clone-d5116.firebaseio.com",
  projectId: "react-slack-clone-d5116",
  storageBucket: "react-slack-clone-d5116.appspot.com",
  messagingSenderId: "430925178412"
};
firebase.initializeApp(config);

export default firebase;
